import { ChangeEvent, useEffect, useState } from "react";
import { useModal } from "../../../../../../hooks/ModalContext";
import { Button } from "../../../../../generics/button";
import { Input } from "../../../../../generics/input-group";
import { Radio } from "../../../../../generics/radio";
import { SelectTipo } from './components/select-tipo'
import { SelectSituacao } from './components/select-situacao'
import { useCadastro } from "../../../../../../context/CadastroContext";
// import { aplicarMascara } from '../../../../../../utils/mascaraTelefone'
import { SelectTelefone } from './components/select'
import { useMutation } from "@tanstack/react-query";
import { apiModulo } from "../../../../../../services/api";
import { useDividas } from "../../../../../../context/DividasContext";
import { DadosCadastrais, Endereco } from "../../../../../../types/devedor-interface";
// import { format } from "date-fns";
import InputMask from 'react-input-mask-next'
import { useAuth } from "../../../../../../context/AuthContext";

interface TelefoneModalProps {
  isToSave?: boolean
  isOperador?: boolean
  app?: string
}

interface DadosTelefone {
  id_telefone?: string;
  tipo_telefone: | "Fixo Residencial"
  | "Fixo Comercial"
  | "Fixo Referencia"
  | "Fixo Trabalho Conjuge"
  | "Movel Particular"
  | "Movel Comercial"
  | "Movel Referencia"
  | "Movel Conjuge"
  | "Outros";
  telefone: string;
  whats: string;
  ramal: string;
  referencia: string;
  tiporeferencia: string;
  ultimaatualizacao: string;
  situacaotelefone: string;
  origemtelefone: string;
  melhoreshorarios: {
    melhorhorario: {
      dia: string;
      horainicial: string;
      horafinal: string;
    }[];
  };
}

export const TelefoneModal = ({ isToSave, isOperador, app }: TelefoneModalProps) => {
  const { infoTel, onClose, setModal } = useModal()
  const { getTelefones, atualizaDevedorCadastro, telefones } = useCadastro()
  const { selectedCredor, devedor, getDevedorCadastro, devedorCadastro } = useDividas()
  const { cookies } = useAuth()


  const [situacao, setSituacao] = useState('Contactado')
  const [tipoTel, setTipoTel] = useState<| "Fixo Residencial"
    | "Fixo Comercial"
    | "Fixo Referencia"
    | "Fixo Trabalho Conjuge"
    | "Movel Particular"
    | "Movel Comercial"
    | "Movel Referencia"
    | "Movel Conjuge"
    | "Outros">('Movel Particular')
  const [isWhats, setIsWhats] = useState(false)
  const [telefone, setTelefone] = useState<DadosTelefone>(infoTel?.id_telefone ? infoTel : {} as DadosTelefone)
  const [tipoRef, setTipoRef] = useState('')
  const [origem, setOrigem] = useState('Manual')
  const appWS = app ? app : isOperador ? 'ACIONA_OPE' : 'ACIONA_WEB'

  const tipoReferencia = useMutation({ mutationFn: () => apiModulo.post('/options', { codcredor: selectedCredor.credor_crm, url: selectedCredor.url_ws, legenda: 'TIPO_TELEFONE_REF', app: appWS, usuario: String(cookies?.user?.id_operador), }) })


  const origemTel = useMutation({ mutationFn: () => apiModulo.post('/options', { codcredor: selectedCredor.credor_crm, url: selectedCredor.url_ws, legenda: 'TELEFONE_ORIGEM', app: appWS, usuario: String(cookies?.user?.id_operador), }) })

  useEffect(() => {
    tipoReferencia.mutateAsync()
    // situacaoTel.mutateAsync()
    origemTel.mutateAsync()

  }, [])


  function formatarTelefone(telefone: string) {
    telefone = telefone.replace(/\D/g, '');
    telefone = telefone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    let nome = name === 'Nome Ref' ? 'referencia' : name
    setTelefone(prevState => ({
      ...prevState,
      [nome.toLocaleLowerCase()]: nome === 'Telefone' ? value.replace(/\D/g, '') : value,
    }));
  };

  function verificarTelefone(telefone: string) {
    if (telefones.find(item => item.telefone === telefone)) {
      return false
    }
    return true
  }

  async function addTelefone(telefone: DadosTelefone) {
    if (telefone.telefone !== '' && !infoTel.telefone) {
      const isEmailExist = verificarTelefone(telefone.telefone)
      if (!isEmailExist) {
        setModal('Telefone já existente na base de dados', 'Erro', false, true)
        return
      }

    }

    let tel: DadosTelefone = {
      tipo_telefone: tipoTel,
      telefone: telefone.telefone,
      whats: isWhats ? 'true' : 'false',
      ultimaatualizacao: '',
      situacaotelefone: situacao,
      origemtelefone: origem,
      tiporeferencia: tipoRef || '',
      referencia: telefone.referencia || '',
      ramal: telefone.ramal || '',
      melhoreshorarios: {
        melhorhorario: []
      }
    }

    if (infoTel.id_telefone) {
      tel.id_telefone = infoTel.id_telefone
    }

    if (tel.telefone === '') {
      setModal('o campo de telefone não pode estar vazio', 'Erro', false, true)
      return
    }

    if (isToSave) {
      const cpf_cnpj = devedor?.cpf_cnpj.replace(/\D/g, '') || ''
      const codcredor = String(selectedCredor.credor_crm) || ''
      const url = selectedCredor.url_ws || ''
      const status = await atualizaDevedorCadastro({ dadosCadastrais: {} as DadosCadastrais, endereco: {} as Endereco, cpf_cnpj, url, codcredor, telefone: tel, usuario: String(cookies?.user?.id_operador), nomeclien: devedor.name, datnasc: devedorCadastro?.datnasc })
      await getDevedorCadastro(url, cpf_cnpj, Number(codcredor), appWS, String(cookies?.user?.id_operador),)

      if (status === 200) {
        setModal('Devedor atualizado com sucesso!', 'Sucesso', true)
      }
    } else {
      // console.log(tel)
      getTelefones(tel, infoTel.telefone)
    }
    onClose()
  }


  useEffect(() => {
    if (infoTel?.tipo_telefone) {
      const tipoTelefone = infoTel.tipo_telefone || '';
      setTipoTel(tipoTelefone)
    }

    if (infoTel.situacaotelefone) {
      setSituacao(infoTel?.situacaotelefone)
    }

    if (infoTel.origemtelefone) {
      setOrigem(infoTel?.origemtelefone)
    }

    if (infoTel.tiporeferencia) {
      setTipoRef(infoTel?.tiporeferencia)
    }
    if (infoTel.whats) {
      setIsWhats(infoTel.whats === 'true' ? true : false)
    }
  }, [infoTel])

  //SELECTS
  //   TELEFONE_SITUACAO
  // TELEFONE_ORIGEM
  // TIPO_TELEFONE_REF

  function verifyTipoTelefone(value: string) {
    if (value === "Fixo Residencial"
      || value === "Fixo Comercial"
      || value === "Fixo Referencia"
      || value === "Fixo Trabalho Conjuge"
      || value === "Movel Particular"
      || value === "Movel Comercial"
      || value === "Movel Referencia"
      || value === "Movel Conjuge"
      || value === "Outros") {
      setTipoTel(value)
    }
  }

  // console.log(infoTel.telefone)

  return (
    <div>
      <div>
        <form className="flex flex-col items-end">
          {/* <Input name="Telefone" placeholder={infoTel?.telefone ? formatarTelefone(infoTel?.telefone) : ''} value={aplicarMascara(telefone.telefone || '')} onChange={(e) => handleChange(e)} maxLength={12} /> */}
          <div className="my-2 flex h-8 w-full items-center justify-between gap-4">
            <p className="w-2/6 font-medium text-gray-700">Telefone: </p>
            <InputMask
              mask="(99) 99999-9999"
              name="Telefone"
              placeholder={infoTel?.telefone ? formatarTelefone(infoTel?.telefone) : ''}
              value={telefone.telefone || infoTel?.telefone}
              onChange={
                (e: ChangeEvent<HTMLInputElement>) => handleChange(e)
              }
              className="h-full w-full bg-gray-200 p-2 placeholder:text-gray-600"
            />

          </div>



          <SelectTipo value={tipoTel} onChange={(e) => verifyTipoTelefone(e.target.value)} />

          <Input name="Ramal" placeholder={infoTel?.ramal ? infoTel?.ramal : ''} onChange={(e) => handleChange(e)} />

          <SelectSituacao isCadastro={infoTel?.id_telefone && infoTel?.id_telefone?.length > 0 ? false : true} value={situacao} onChange={(e) => setSituacao(e.target.value)} />

          {/* <Input name="Tipo de Ref" placeholder={infoTel?.tiporeferencia ? infoTel?.tiporeferencia : ''} onChange={(e) => handleChange(e)} /> */}
          {/* <SelectTelefone items={situacaoTel.data?.data.message?.lista?.item || []} value={situacao} onChange={(e) => setSituacao(e.target.value)} name="situacao" nameSelect="Situação" /> */}

          <SelectTelefone items={tipoReferencia.data?.data.message?.lista?.item || []} value={tipoRef} onChange={(e) => setTipoRef(e.target.value)} name="tiporeferencia" nameSelect="Tipo de Ref" />

          <SelectTelefone items={origemTel.data?.data.message?.lista?.item || []} value={origem} onChange={(e) => setOrigem(e.target.value)} name="origemtelefone" nameSelect="Origem" infoTel={infoTel?.telefone} />

          <Input name="Nome Ref" placeholder={infoTel?.referencia ? infoTel?.referencia : ''} onChange={(e) => handleChange(e)} />

          <div className="mb-4 mt-2 flex h-8 w-full items-center justify-between gap-4">
            <p className="w-2/6 font-medium text-gray-700">Possui WhatsApp: </p>
            <div className="flex items-center gap-4">
              <Radio name="whatsapp" label="Sim" checked={isWhats} onClick={() => setIsWhats(true)} />
              <Radio name="whatsapp" label="Não" checked={!isWhats} onClick={() => setIsWhats(false)} />
            </div>
          </div>
          <Button name="Salvar" width="w-2/6" type="button" onClick={() => { addTelefone(telefone) }} />
        </form>
      </div>
    </div>
  );
};
